<!--考试管理-->
<template>
  <div class="hbn-container">
    <div class="search-form">
      <el-form
        label-width="80px"
        label-position="right"
        size="mini"
      >
        <el-row :gutter="24">
          <el-col :span="18">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="试卷名称">
                  <el-input
                    id="name"
                    v-model="PageQuery.queryModel.name"
                    placeholder="试卷名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="分类">
                  <el-input
                    id="title"
                    v-model="PageQuery.queryModel.title"
                    placeholder="请输入"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="讲师">
                  <el-input
                    id="title"
                    v-model="PageQuery.queryModel.title"
                    placeholder="请输入"
                    clearable
                  />
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button
                size="mini"
                class="hbn-button-serach"
                @click="seach"
              >查找</el-button>
              <span
                class="control-collapse"
                @click="show = !show"
              >{{
              show ? "收起" : "展开"
            }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button newbtn"
          type="primary"
          @click="handleClick(0,'Add')"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>创建试卷</span>
        </el-button>
        <!-- <el-button
          class="custom-button newbtn"
          type="primary"
          @click="goEdit()"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>试卷编辑测试</span>
        </el-button> -->
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template
              v-for="(item, key) in ExamList"
              :key="key"
            >
              <vxe-table-column
                v-if="item.isShow"
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                show-overflow-tooltip
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="200"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex, row }">
                <el-button
                  type="text"
                  size="small"
                  v-if="row.status==0"
                  @click="handleClick(rowIndex, 'Publish')"
                >发布</el-button>
                <el-button
                  type="text"
                  size="small"
                  v-show="false"
                  v-if="row.status==1"
                  @click="handleClick(rowIndex, 'End')"
                >结束</el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="row.status==0"
                  @click="handleClick(rowIndex, 'Modify')"
                >编辑</el-button>

                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Detail')"
                >查看</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="Opt(row, 'QRCode')"
                >查看二维码</el-button>

                <el-button size="small" type="text" @click="handleClick(rowIndex, 'Delete')">删除</el-button>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
    <WXQRCode ref="qrcode"></WXQRCode>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import {ExamList} from "@/assets/apiData/Exam/ExamList";
import { dateFormat } from "@/util/utils.js";

import {
  GetDataExamListByPageQuery,
  PublishExam,
  DeleteExam
} from "@api/Exam/ApiExam";
import { ref } from "vue";
import WXQRCode from "@comp/QRCode/WXQRCode.vue";

export default {
  name: "ExamManagement",
  data() {
    return {
      router:useRouter(),
      PageQuery: {
        queryModel: {
          name: "",
          sortField: {
            CreationTime: "desc",
          },
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      show: false,
      ExamList: [],
      DataList: [],
      statusList:[{name:'已创建',code:0},{name:'已发布',code:1},{name:'已结束',code:2}]
    };
  },
  components: {
    WXQRCode
  },
  methods: {
    handleClick(index, type) {
      var _this = this;
      if (type == "Delete") {
        this.$messageBox.confirm(
          `您确定删除吗？`,
          "提示",
          {
            cancelButtonClass: "cancelstyle",
            confirmButtonClass: "confirmstyle",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          }
        ).then(() => {
          DeleteExam(_this.DataList[index].id).then(function (data) {
            if (data) {
              _this.$message.success("删除成功");
              _this.PageQuery.pageindex = 1;
              _this.GetData();
            }
          });
        }).catch(()=>{

        });
      }
      else if(type == "Publish")
      {
        PublishExam(_this.DataList[index].id,0).then(res=>{
          _this.DataList[index].status=1
          this.$message.success("发布成功")
        }).catch(res=>{
          this.$message.error(res.message)
        })
      }
      else
      {
          localStorage.setItem('Exam_senddata', JSON.stringify({ operation: type, main: _this.DataList[index] }));
          this.goEdit();
          // this.router.replace({
          //   name: "试卷中心",
          //   params: {
          //     from: "ExamManagement",
          //     isReplace: true,
          //   },
          // });
      }
    },
    goEdit(){
      this.router.replace({
        name: "试卷管理",
        params: {
          from: "ExamManagement",
          isReplace: true,
        },
      });
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "status":
          let item = this.statusList.find(x=>x.code==cellValue);
          if(item) {
            cellValue = item.name;
          }
          // cellValue = this.statusList.find(x=>x.code==cellValue).name;
          break;
      }
      return cellValue;
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      //this.GetData();
    },
    GetData() {
      const _this = this;
      const loading = this.loading()
      try {
        GetDataExamListByPageQuery(this.PageQuery).then(function (
          data
        ) {
          loading.close();
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        loading.close();
        console.log(e);
      }
    },
  },
  mounted() {
    this.ExamList = ExamList
    this.GetData();
  },
  setup(props){
    const qrcode = ref(null);
    //操作节点
    const Opt = (row, name) => {
      switch (name) {
        case "QRCode": // 生成小程序码
          let query = {
            examId: row.id,
            answerDate: row.answerDate,
          };
          qrcode.value.getQRCode(
            "pages/exam/takeExam",
            row.name,
            query
          );
          break;
      }
    };
    return {
      qrcode,
      Opt
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
.newbtn {
  width: 85px !important;
}
</style>